module.exports = __webpack_public_path__ + "static/media/support.75a89a87.svg";